import setPublicPath from 'app/setPublicPath'
import React from 'react'
import thunkInject from 'redux-thunk-inject'
import { createBrowserHistory } from 'history'
import { hydrate } from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import cookiesMiddleware, { getStateFromCookies } from '@ynap/redux-cookies-middleware'
import { createFetchWcs } from '@ynap/fetch'
import { getHeadConfig } from '@ynap/config-state'
import { raygun } from '@ynap/clientside-monitoring'
import { AppContainer as HotLoadAppContainer } from 'react-hot-loader'
import { createInstance } from '@ynap/optimizely-utils'

import appReducer from 'app/appReducer'
import app from 'app'

const isProd = process.env.NODE_ENV === 'production'

const renderFunction = (messages) => {
    const cookiePaths = { uberToken: { name: 'ubertoken' } }
    // we need to initialise fetch with a store BEFORE middleware, so have to pass a ref and update as soon as the store is created
    const storeRef = {}
    const fetchWcs = createFetchWcs(fetch, storeRef)

    const history = createBrowserHistory()
    const initialState = getStateFromCookies(window.MA.state, cookiePaths)
    const commonMiddleware = applyMiddleware(
        routerMiddleware(history),
        thunkInject(fetchWcs),
        cookiesMiddleware(cookiePaths)
    )

    setPublicPath(initialState.config.head.assetsBaseUrl)

    if (!initialState.appState) {
        initialState.appState = {}
    }

    if (!initialState.auth) {
        initialState.auth = {}
    }

    initialState.auth.uberToken = initialState.uberToken
    initialState.appState.messages = messages

    const store = createStore(
        appReducer(history),
        initialState,
        !isProd ? composeWithDevTools(commonMiddleware) : commonMiddleware
    )

    storeRef.getState = store.getState
    storeRef.dispatch = store.dispatch

    if (window) {
        window.__store = store
    }

    const state = store.getState()
    const headConfig = getHeadConfig(state)

    if (headConfig.raygun && headConfig.raygun.enabled && headConfig.raygun.apiKey) {
        raygun.agent.init(headConfig.raygun)
        raygun.helpers.routerTrackEvent(history)
    }

    const useSifuOptimizely = !headConfig?.optimizely?.mockOptimizely

    const sdkKey = headConfig?.optimizely?.sdkKey
    const datafile = window.optimizelyState?.datafile
    const optimizely =
        window.optimizelyCreateInstance && useSifuOptimizely
            ? window.optimizelyCreateInstance
            : (sdkKey || datafile) &&
              createInstance({
                  sdkKey,
                  datafile: window.optimizelyStateMA?.datafile,
                  datafileOptions: {
                      autoUpdate: true,
                      updateInterval: 600000, // 10 minutes in milliseconds
                  },
                  disableLogger: false, // turn on logs for dev env
              })

    if (!isProd && module.hot) {
        module.hot.accept(['../app'], () => {
            const nextApp = require('../app').default // eslint-disable-line @typescript-eslint/no-var-requires
            hydrate(
                <HotLoadAppContainer>{nextApp(store, history, messages, headConfig, optimizely)}</HotLoadAppContainer>
            )
        })

        module.hot.accept(['../app/appReducer'], () => {
            const nextAppReducer = require('../app/appReducer').default // eslint-disable-line @typescript-eslint/no-var-requires
            store.replaceReducer(nextAppReducer(history))
        })
    }

    hydrate(app(store, history, messages, headConfig, optimizely), document.querySelector('.ma-wrapper'))
}

export default renderFunction
